import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React from 'react';

export const AbsoluteContainer = (props: BoxProps) => (
  <Box
    bottom={0}
    justifyContent="center"
    left={0}
    position="absolute"
    right={0}
    top={0}
    {...props}
  />
);
